import Kundhandelsetyp from "../../model/kundhandelsetyp";
import Producentarendetyp from "../../model/producentarendetyp";
import DataModel from "../../scripts/dataModel";

export async function getByProducentarendetypId(idParameter: string): Promise<Kundhandelsetyp[]> {
    const promise = new Promise<Kundhandelsetyp[]> ((resolve, reject) => {
        const filtered = DataModel.getInstance().kundhandelsetyper.filter((p) => {
            return p.producentarendetyp.dbId === idParameter
        })
        resolve(filtered)
    })

    return promise

}